import { MessageCircle } from "lucide-react";

const WHATSAPP_NUMBER = "17865064537";
const MESSAGE = "Hi KK Beauty & Fashion! I have a question about your products.";

export const WhatsAppButton = () => {
  const href = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(MESSAGE)}`;
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat with us on WhatsApp"
      data-testid="whatsapp-button"
      className="fixed bottom-5 right-5 z-50 flex items-center gap-2 rounded-full bg-[#25D366] px-4 py-3 text-white shadow-lg transition-transform duration-300 hover:scale-105 hover:bg-[#1ebe57]"
    >
      <MessageCircle size={22} className="fill-white" />
      <span className="hidden text-sm font-medium sm:inline">Chat with us</span>
    </a>
  );
};
